import {View} from 'MWC';
import tpl from '../templates/TabsNew.jsx';
import PropTypes from 'prop-types';

const SLIDER_INIT_DELAY = 100;

export default class extends View {
    template = tpl;

    initializedMode = null;
    pendingScrollTimer = null;
    ignoreNextScrollFromToggle = false;

    constructor(props) {
        super(props);
        this.state = {
            ui: this.uiStates.INITIAL,
            showModal: false,
            modes: props.modes,
            mode: props.initTab ? props.modes[+props.initTab].mode : props.modes[0].mode
        };
        this.play = this.play.bind(this);
        this.pause = this.pause.bind(this);

        this.toggleMode = this.toggleMode.bind(this);
        return this;
    }

    play() {
        this.slider.slickPlay();
    }

    pause() {
        this.slider.slickPause();
    }

    toggleMode = (e, mode) => {
        const target = e.target;

        this.ignoreNextScrollFromToggle = true;

        this.setState({mode: mode || target.name});
        if (this.props.toggle) {
            this.props.toggle(mode || target.name);
        }
        if (this.slider) {
            this.pause();
            this.play();
        }
    };

    scheduleScrollToActiveMode = (modeToScroll, force = false) => {
        if (!this.props.activeTabVisible) return;
        if (!this.slider) return;
        if (!modeToScroll) return;
        if (!force && this.initializedMode === modeToScroll) return;
        if (!force && this.ignoreNextScrollFromToggle) return;

        clearTimeout(this.pendingScrollTimer);

        this.pendingScrollTimer = setTimeout(() => {
            if (!this.slider || !this._isMounted) return;

            const index = this.state.modes.findIndex(m => m.mode === modeToScroll);
            if (index >= 0) {
                this.slider.slickGoTo(index);
                this.initializedMode = modeToScroll;
            }
        }, SLIDER_INIT_DELAY);
    };

    componentDidMount() {
        this._isMounted = true;

        this.unlisten = this.context.history.listen(() => {
            if (!this._isMounted) return;

            this.initializedMode = null;
            this.ignoreNextScrollFromToggle = false;
            this.scheduleScrollToActiveMode(this.props.mode);
        });

        this.scheduleScrollToActiveMode(this.props.mode);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.mode !== this.props.mode) {
            if (this.ignoreNextScrollFromToggle) {
                this.ignoreNextScrollFromToggle = false;
            } else {
                this.scheduleScrollToActiveMode(this.props.mode);
            }
        }

        if (!prevProps.isMobile && this.props.isMobile) {
            this.initializedMode = null;
            this.scheduleScrollToActiveMode(this.props.mode, true);
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
        if (this.unlisten) this.unlisten();
        if (this.pendingScrollTimer) clearTimeout(this.pendingScrollTimer);
    }

    static defaultProps = {
        title: 'Put your title here',
        id: ''
    };

    static contextTypes = {
        history: PropTypes.object
    };
}
